import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import { Autocomplete, Button, TextField } from '@mui/material';
import customStyles from 'app/shared-components/SelectCustomStyle';
import React from 'react'
import { useState } from 'react';
import Select from 'react-select'
import AgGridTable from '../../utilities/AgGridTable';

const ShowAttendance = ({setPage}) => {
    const [searchType, setSearchType] = useState("byEmployeeName");
    // const [searchBy, setSearchBy] = useState(initialValue)
    const [columnDefs, setColumnDefs] = useState([
        { field: 'employee', enableRowGroup: true, },
        { field: 'OFC', enableRowGroup: true, },
        { field: 'BW', enableRowGroup: true, },
        { field: 'HO', enableRowGroup: true, },
        { field: 'BT', enableRowGroup: true, },
        { field: 'personal', enableRowGroup: true, },
        { field: 'annualLeave', enableRowGroup: true, },
        { field: 'sickLeave', enableRowGroup: true, },
        { field: 'unpaidLeave', enableRowGroup: true, },
        { field: 'maternity', enableRowGroup: true, },
        { field: 'parental', enableRowGroup: true, },
        { field: 'publicHoliday', enableRowGroup: true, },
        { field: 'variable', enableRowGroup: true, },
    ]);

    const searchOption = [
        { value: "byPepoleInOffice", label: "Pepole In Office" },
        { value: "byVacation", label: "Vacation" },
        { value: "bySickLeave", label: "Sick Leave" },
    ]

    const handleSearchTypeChange = (data) => {
        setSearchType(data.value);
    }

    return (
        <>
            <div className='flex'>
                <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 space-x-8 m-16">
                    <label className="pt-12">Filter By</label>
                    <Select name="searchType"
                        value={(searchType && searchOption) && searchOption.filter(obj => searchType.includes(obj.value))}
                        onChange={handleSearchTypeChange}
                        className="w-[200px]"
                        options={searchOption}
                        styles={customStyles()}
                    />

                </div>
                <div>
                    <Button
                        className="mt-24"
                        onClick={() => setPage(0)}
                        variant="contained" color="warning"
                    >
                        <FuseSvgIcon>heroicons-outline:arrow-circle-left</FuseSvgIcon>
                    </Button>
                </div>
            </div>
            <div className="h-full">
                <AgGridTable
                    // ref={gridRef}
                    rowData={[]}
                    columnDefs={columnDefs}
                    hideCheckbox={true}
                    suppressRowCount={true}
                // defaultColDef={defaultColDef}
                // onGridReady={onGridReady}
                />
            </div>
        </>
    )
}

export default ShowAttendance